import { render, staticRenderFns } from "./DataSoftwareProduct.vue?vue&type=template&id=85b79c54&scoped=true"
import script from "./DataSoftwareProduct.vue?vue&type=script&lang=js"
export * from "./DataSoftwareProduct.vue?vue&type=script&lang=js"
import style0 from "./DataSoftwareProduct.vue?vue&type=style&index=0&id=85b79c54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b79c54",
  null
  
)

export default component.exports